export const LOADING = 'loading'
export const DISABLED = 'disabled'
export const FULL = 'full'
export const UPDATING = 'updating'
export const LOCKED = 'locked'
